import { type PrimitiveType, useIntl } from "react-intl";

import type { IMessagesType } from "@domain/intl/translations/de";

export type MessageId = keyof IMessagesType;

export const useTranslation = () => {
    const intl = useIntl();
    return {
        t: (id: MessageId, values?: Record<string, PrimitiveType>) => intl.formatMessage({ id }, values),
        intl,
        locale: intl.locale,
    };
};
